import http from "../../../request";

export default {
  contacts: async (context) => {
    let response = await http.get("contacts", localStorage.getItem("lang"));

    context.commit("setContacts", response);
  },
};
